import React, { MutableRefObject } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "components/dashboard/Modal";
import closeSvg from "../assets/svg/close.svg";
import spinnerSvg from "../assets/svg/spinner-blue.svg";

type Props = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  stopLoginWithToken: MutableRefObject<boolean>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export const RemoteAuthentictionModal: React.FC<Props> = ({
  showModal,
  setShowModal,
  stopLoginWithToken,
  setLoading,
}) => {
  const { t } = useTranslation();
  const CloseButton = () => {
    return (
      <button
        onClick={() => {
          stopLoginWithToken.current = true;
          setLoading(false);
          setShowModal(false);
        }}
        type="button"
        className="-mr-2"
      >
        <img className="h-8" src={closeSvg} alt="close" />
      </button>
    );
  };
  return (
    <Modal
      showOverflow
      customModal={
        <div className="w-full h-full py-4 px-2 bg-slate-900 rounded-md">
          <div className="w-full flex pr-2 justify-end ">
            <CloseButton />
          </div>
          <div className="flex pb-2 px-4 text-slate-200 justify-center text-xl">
            {t("admin.remoteAuthenticationTitle")}
          </div>
          <div className="flex py-1 px-4 text-slate-200 justify-center">
            <img
              className="h-20 animate-spin"
              src={spinnerSvg}
              alt="loading spinner"
            />
          </div>
          <div className="flex pb-6 px-4 text-slate-200">
            {t("admin.remoteAuthenticationText")}
          </div>
        </div>
      }
      show={showModal}
    />
  );
};
